import getClosest from '@/utils/get-closest'

export default target => {
  // Climb out of svg elements
  if (target instanceof SVGElement) {
    if (target.nodeName === 'svg') {
      return target.parentNode
    } else {
      const svg = getClosest(target, 'svg')
      return svg.parentNode
    }
  }
  // else return normal target
  return target
}
